import { Component, Input, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import {
  DocumentInputButton,
  ModeDocumentationInput,
  StylinMode,
} from '../../../base/src/abcDocumentInput/abcDocumentInput';
@Component({
    selector: '',
    template: `
    <dx-text-box
      [id]="id"
      [value]="value"
      [placeholder]="placeholder"
      [class]="class"
      [visible]="visible"
      [disabled]="disabled"
      [stylingMode]="stylingMode"
      [mode]="mode"
      [rtlEnabled]="rtlEnabled"
      (valueChange)="dataChanged($event)"
      >
      @for (button of buttonList; track button) {
        <dxi-text-box-button [name]="button.name" [options]="button"></dxi-text-box-button>
      }
    </dx-text-box>
    `,
    styles: [':host::ng-deep .dx-button-content { padding:2px;}'],
    standalone: false
})
export class DevExDocumentInputComponent implements OnInit {
  @ViewChild('dxDocInput', { static: true }) dxDocInput;
  @Input() id: string;
  @Input() placeholder: string;
  @Input() value: any;
  @Input() width: string;
  @Input() height: string;
  @Input() class: string;
  @Input() disabled: boolean;
  @Input() mode: ModeDocumentationInput;
  @Input() visible: boolean = true;
  @Input() rtlEnabled: boolean = false;
  @Input() stylingMode: StylinMode = StylinMode.Underlined;
  @Input() buttonList: DocumentInputButton[];
  @Output() onChange: EventEmitter<any> = new EventEmitter();

  constructor() {}
  ngOnInit() {}

  dataChanged(value) {
    this.onChange.emit(value);
  }
}
